import { Card, GKTypography, Grid2 } from "components";
import { numberToCurrency } from "utils/MathFunction";
import NetContributionChart from "./NetContributionChart";

const CardOne = ({ data, loading }: any) => {
  return (
    <Card sx={{ p: 0, height: "100%" }}>
      <Grid2 container>
        <Grid2
          size={12}
          p={2}
          borderBottom={`solid 1px var(--neutral-100)`}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={1}
        >
          <GKTypography
            fontSize={14}
            fontWeight={600}
            display={"flex"}
            alignItems={"center"}
            gap={0.5}
            width={"50%"}
          >
            Net Contribution
          </GKTypography>
          <GKTypography fontSize={18} fontWeight={600} loading={loading}>
            {numberToCurrency(data?.netContribution)}
          </GKTypography>
        </Grid2>
        <Grid2 size={12} pt={2}>
          <NetContributionChart data={data} loading={loading} />
        </Grid2>
        <Grid2
          size={12}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          p={"16px"}
        />
        <Grid2
          size={12}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          py={"0px"}
          px={"16px"}
          mb={2}
        >
          <GKTypography
            display={"flex"}
            alignItems={"center"}
            fontWeight={400}
            fontSize={12}
            color={"var(--neutral-500)"}
            width={"50%"}
          >
            <span
              style={{
                height: 26,
                width: 4,
                borderRadius: "10px",
                marginRight: 8,
                background: "#FCAA67",
              }}
            />
            Net Contribution
          </GKTypography>
          <GKTypography
            fontWeight={600}
            fontSize={12}
            color={"#495567"}
            loading={loading}
          >
            {numberToCurrency(data?.netContribution)}
          </GKTypography>
        </Grid2>
        <Grid2
          size={12}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          py={"0px"}
          px={"16px"}
          mb={2}
        >
          <GKTypography
            display={"flex"}
            width={"50%"}
            alignItems={"center"}
            fontWeight={400}
            fontSize={12}
            color={"var(--neutral-500)"}
          >
            <span
              style={{
                height: 26,
                width: 4,
                borderRadius: "10px",
                marginRight: 8,
                background: "#709D88",
              }}
            />
            Pay In
          </GKTypography>
          <GKTypography
            fontWeight={600}
            fontSize={12}
            color={"#495567"}
            loading={loading}
          >
            {numberToCurrency(data?.payIn)}
          </GKTypography>
        </Grid2>
        <Grid2
          size={12}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          mb={2}
          py={"0px"}
          px={"16px"}
        >
          <GKTypography
            display={"flex"}
            alignItems={"center"}
            fontWeight={400}
            fontSize={12}
            width={"50%"}
            color={"var(--neutral-500)"}
          >
            <span
              style={{
                height: 26,
                width: 4,
                borderRadius: "10px",
                marginRight: 8,
                background: "#39627A",
              }}
            />
            Pay Out
          </GKTypography>
          <GKTypography
            fontWeight={600}
            fontSize={12}
            color={"#495567"}
            loading={loading}
          >
            {numberToCurrency(data?.payOut)}
          </GKTypography>
        </Grid2>
      </Grid2>
    </Card>
  );
};

export default CardOne;
